var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Layout',[_c('PageHeader',{attrs:{"title":_vm.title,"items":_vm.items}}),_c('b-container',{staticClass:"p-0",attrs:{"fluid":""}},[_c('b-row',[_c('b-col',[_c('b-card',{staticClass:"shadow"},[_c('BaseDatatable',{ref:"table",attrs:{"drfprovider":_vm.myProvider,"tableheaders":_vm.tableHeaders},scopedSlots:_vm._u([{key:"buttons",fn:function(){return [_c('b-button',{attrs:{"variant":"outline-primary rounded-lg shadow-sm","size":"sm"},on:{"click":function($event){return _vm.openCreateUpdateModal(null, null)}}},[_c('i',{staticClass:"fas fa-plus"})])]},proxy:true}])})],1)],1)],1)],1),(_vm.showForm)?_c('UploadData',{attrs:{"type_action":_vm.typeAction,"fullform":true,"instanceJson":_vm.toUpdate || {},"oncomplete":() => {
        _vm.showForm = false
        _vm.toUpdate = {}
        _vm.$refs.table.refresh()
      },"oncancel":() => {
        _vm.showForm = false
        _vm.toUpdate = {}
      }}}):_vm._e(),(_vm.showFormEdit)?_c('cardholderForm',{attrs:{"instanceJson":_vm.toUpdate || {},"oncomplete":() => {
        _vm.showFormEdit = false;
        _vm.toUpdate = {};
        _vm.$refs.table.refresh()
      },"oncancel":() => {
        _vm.showFormEdit = false;
        _vm.toUpdate = {}
      }}}):_vm._e(),(_vm.showFormDelete)?_c('cardholderDelete',{attrs:{"instanceJson":_vm.toDelete,"oncomplete":() => {
        _vm.showFormDelete = false;
        _vm.toDelete = {};
        _vm.$refs.table.refresh()
      },"oncancel":() => {
        _vm.showFormDelete = false;
        _vm.toDelete = {}
      }}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }